import { render } from "./SidePanel.vue?vue&type=template&id=3dfdc056"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=3dfdc056&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__